import React from 'react';
import { TrustLayout, TrustHero, TrustSection, TrustList, RelatedLinks, TrustCta } from '../components/website/TrustPage';

const SERVICE = [
  { title: 'Adjustments', text: 'Many adjustments, such as motor limit settings or re-tensioning a clutch, can be handled quickly.' },
  { title: 'Warranty repairs', text: 'Coordinated by our Brooklyn-based service team with the manufacturer where needed.' },
];

export default function WarrantyServicePage() {
  return (
    <TrustLayout>
      <TrustHero testId="warranty" eyebrow="After Installation" title="Warranty & Service"
        intro="Your shades are covered by the warranty terms provided with your order, and our Brooklyn-based team is here for adjustments and service after installation." />
      <TrustSection title="Warranty coverage" testId="warranty-coverage">
        <p>Apollo Shades products are covered by the warranty terms provided with your order, together with the manufacturer warranties for motors and components.</p>
        <p>Coverage depends on the product and motor, so we confirm the terms for your products with your quote.</p>
        <p className="text-sm text-neutral-500">Warranties do not cover misuse, improper care, normal wear, or damage caused by others.</p>
        <RelatedLinks links={[{ to: '/terms', label: 'Terms of service' }]} />
      </TrustSection>
      <TrustSection title="Service" muted testId="warranty-service-list">
        <TrustList items={SERVICE} testId="warranty-service-items" />
      </TrustSection>
      <TrustSection title="Requesting service" testId="warranty-request">
        <p>Call us or send a message with your name, address and a short description of the issue. If you have your order or quote number, include it so we can find your products quickly.</p>
        <RelatedLinks links={[{ to: '/contact', label: 'Contact us' }, { to: '/service-area', label: 'Service area' }, { to: '/measuring-installation', label: 'Measuring & installation' }]} />
      </TrustSection>
      <TrustCta title="Planning new shades?" text="Book a free consultation or request a quote, and we will confirm the warranty terms for the products you choose." />
    </TrustLayout>
  );
}
